export function exportPayroll(payroll, list) {
    const csvData = list.map(item => ({
        'Client Name': item.client_name,
        'Worker Name': item.worker_name,
        'Period Ending': item.period_ending,
        'Regular Hours': item.regular_hours,
        'Regular Rate': item.regular_rate,
        'Overtime Hours': item.overtime_hours,
        'Overtime Rate': item.overtime_rate,
        'Doubletime Hours': item.doubletime_hours,
        'Doubletime Rate': item.doubletime_rate,
        'Deliverables/Adjustments': item.payment_type === 'deliverable' || item.payment_type === 'adjustment' ? item.amount : '',
        Expenses: item.payment_type === 'expense' ? item.amount : ''
    }));
    const fileName = `${payroll.name}-PayrollExport`;

    return {
        csvData,
        fileName
    };
}

export function exportExecupayPayroll(payroll, list) {
    const csvData = list.map(item => ({
        'Client Code': item.client_code,
        'Employee Number': item.employee_number,
        Division: '',
        Department: '',
        Type: item.type,
        Code: item.code,
        'Pay Rate': item.pay_rate,
        'Rate #': item.rate_no,
        'Regular Hours': item.regular_hours,
        'Overtime Hours': item.overtime_hours,
        Amount: item.amount,
        'Job 1': item.job_1,
        'Job 2': item.job_2,
        'Job 3': item.job_3,
        'Job 4': item.job_4,
        'Job 5': item.job_5,
        Date: item.date,
        'Week Number': item.week_number
    }));
    const fileName = `${payroll.name}-ExecupayExport`;

    return {
        csvData,
        fileName
    };
}



// WEBPACK FOOTER //
// ./src/pages/payrolls/exports/payroll.jsx